var _rect, _text, _text2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEkProposal5Wordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 72",
    role: "img",
    "aria-label": "Engin Kaya",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 72,
    rx: 16,
    fill: "#ffffff",
    opacity: 0.95
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 48,
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 32,
    fontWeight: 800,
    letterSpacing: -1,
    fill: "#0f172a"
  }, "engin")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 48,
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 32,
    fontWeight: 800,
    letterSpacing: -1,
    fill: "#00bdfe"
  }, "kaya")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 192,
    height: 3,
    rx: 1.5,
    fill: "#00bdfe",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkProposal5Wordmark);
export default __webpack_public_path__ + "static/media/ek-proposal-5-wordmark.383e75674e06d1a695767f716c41b372.svg";
export { ForwardRef as ReactComponent };